/* eslint-disable global-require */

import angular from 'angular';

import RegistrationFormController from './registration-form.controller';

export default angular.module('autoboard.formRegistration', [])
  .directive('formRegistration', () => {
    'ngInject';

    return {
      controller: RegistrationFormController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '<',
      },
      templateUrl: require('./registration-form.template.html'),
    };
  })
  .name;
